import { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import useInit from './hooks/useInit'
import DeleteModal from 'shared/components/DeleteModal'
import { apiUrls, tableColumnWidths, roles } from 'consts'
import getRows from './utils/getRows'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import SearchPanelInput from 'shared/components/SearchPanelInput'
import Footer from 'shared/components/Footer'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import getPageSize from 'utils/getPageSize'
import unlockAccount from './utils/unlockAccount'

const Users: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})
  const { store } = useContext(ReactReduxContext)

  const [selectedUserIndexes, setSelectedUserIndexes] = useState<any>([])

  const isSuperAdmin: boolean = hasAnyRole([roles.superAdmin])

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'id', title: 'ID' },
    { name: 'concatened', title: 'Name' },
    { name: 'email', title: 'Email' },
    { name: 'role', title: 'Role' },
    { name: 'active', title: 'Active' },
    { name: 'action', title: 'Actions', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'id', width: tableColumnWidths.id },
    { columnName: 'concatened', width: 'auto' },
    { columnName: 'email', width: 'auto' },
    { columnName: 'role', width: 'auto' },
    { columnName: 'active', width: tableColumnWidths.active },
    { columnName: 'action', width: tableColumnWidths.extended_action },
  ]




  useInit({
    getRows,
    setRows,
    setDeleteEntryId,
    setShowModal,
    setShowOverlay,
    unlockAccount,
    currentCustomer,
  })

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='with-action' />
  )

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({
      addUrl: '/add-user',
      addText: 'Add User',
      inputProps: props,
    })
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      headerInsert={
        <>
          {hasAnyRole([roles.superAdmin]) && (
            <HeaderCustomerSelect
              setShowOverlay={setShowOverlay}
              handleCustomerChanged={(customer) => setCurrentCustomer(customer)}
            />
          )}
        </>
      }
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <SortingState defaultSorting={[{ columnName: 'email', direction: 'asc' }]} />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <IntegratedSorting />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <PagingState defaultCurrentPage={0} pageSize={getPageSize()} />
          <IntegratedPaging />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>
        {isSuperAdmin && (
          <>
            <DeleteModal
              url={apiUrls.users}
              showModal={showModal}
              setShowModal={setShowModal}
              deleteEntryId={deleteEntryId}
              setDeleteEntryId={setDeleteEntryId}
              entityName='User'
              getRows={getRows}
              setRows={setRows}
              customConfirmMessage={{
                rows,
                confirmMessage: (row) => {
                  let confirmMessage = 'Are you sure you want to delete this User'

                  if (row.includes_roles) {
                    confirmMessage += ' with all included Roles'
                  }
                  confirmMessage += '? '

                  return confirmMessage
                },
              }}
            />
          </>
        )}
      </>
    </Layout>
  )
}

export default Users
